import React from "react";
import { useTranslation } from "react-i18next";

const TakeResultStep4 = ({ result, selectedInsightRecommendation }) => {
  const { t } = useTranslation();

  // Handle missing or invalid data
  if (
    !result?.data?.quest_result ||
    !Array.isArray(selectedInsightRecommendation) ||
    selectedInsightRecommendation.length === 0
  ) {
    return (
      <section className="flex flex-col items-center w-full max-w-[396px] mx-auto">
        <div className="text-center text-red-500 py-5">
          {t("error.noResultData")}
        </div>
      </section>
    );
  }

  // Convert selectedInsightRecommendation to an object by taking the first item
  const recommendation = selectedInsightRecommendation[0];

  return (
    <section className="flex flex-col items-center w-full max-w-[396px] mx-auto">
      <article className="p-4 bg-yellow-50 rounded-xl text-zinc-800 w-full">
        <div>
          <h2 className="text-base font-semibold">
            {t("base.recommendation")}
          </h2>
          <article className="px-3 py-2 mt-2 bg-white rounded-lg">
            <p className="text-xs font-medium">
              {recommendation.focus_area || t("questResult.noRecommendation")}
            </p>
          </article>
        </div>
        {Array.isArray(recommendation.step_suggestion) &&
          recommendation.step_suggestion.length > 0 && (
            <div className="mt-3">
              <h2 className="text-base font-semibold">{t("base.steps")}</h2>
              <ul className="mt-2 space-y-2">
                {recommendation.step_suggestion.map((step, index) => (
                  <li key={index}>
                    <article className="flex items-start px-3 py-2 bg-white rounded-lg">
                      <span className="px-1 mr-2 text-xs text-white bg-[#3F54DF] rounded-lg w-5 h-5 flex items-center justify-center">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <p className="flex-1 text-xs font-medium">
                        {step.content || t("base.noStepSuggestion")}
                      </p>
                    </article>
                  </li>
                ))}
              </ul>
            </div>
          )}
      </article>
    </section>
  );
};

export default TakeResultStep4;
